import Store from 'App/babel/store';

export default function ListUserDefinedObjectsAllowed() {
	const state = Store.getState();
	const features = state.App.accountSelf?.features;

	return features?.userDefinedObjects;
}
